import { useSelector } from 'react-redux';
import { useExpandedMode } from '../../pages/configuration-canvas/panels-reserve-space/useExpandedMode';
import { DownloadAsCsvButton } from '../shared/csv/DownloadAsCsvButton';
import { getMetadataLabel } from '../tabs/getMetadataLabel';
import { selectActiveDocumentationPageTab } from '../../../reducers/documentation/documentationPageReducer';
import { selectDefaultCreationEnvironment } from '../../pages/environments/environmentsReducer';
import { getCsvHeaders } from '../shared/csv/utils';
import { useMetadataList } from './useMetadataList';

export const DownloadMetadata = () => {
  const { isExpandedMode } = useExpandedMode();
  const activeTab = useSelector(selectActiveDocumentationPageTab);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);

  const { items, metadataColumns } = useMetadataList(crmOrg?.id ?? '', activeTab ?? '');

  if (!activeTab) return null;

  const label = getMetadataLabel(activeTab);
  const csvHeaders = getCsvHeaders(metadataColumns);

  const biEventProps = {
    numberOfRecords: items?.length ?? 0,
    exportType: label ?? '',
  };

  return (
    <DownloadAsCsvButton
      fileName={`${crmOrg?.name}_${label}_Export_from_Sweep`}
      headers={csvHeaders}
      rows={items}
      biEventProps={biEventProps}
      buttonSize={isExpandedMode ? 'small' : 'tiny'}
      withButtonLabel
    />
  );
};
